import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
// eslint-disable-next-line camelcase
import zh_CN from 'vee-validate/dist/locale/zh_CN.json';
import deviceApi from '@/api/deviceAndPointCodeManage/device';
import pointApi from '@/api/deviceAndPointCodeManage/point';
// Install required rule and message.
extend('required', {
  ...required,
  message: zh_CN.messages.required,
});

extend('existPC', {
  validate: async value => {
    const response = await pointApi.checkNotExistsPoint([value]);

    if (response.data.length === 0) {
      return true;
    }

    return '点位不存在';
  },
});
// 根据设备编码，检查设备是否存在
extend('existDC', {
  validate: async value => {
    try {
      // 调用后端接口，判断设备是否存在
      const response = await deviceApi.checkDeviceExist({ deviceCode: value });
      // console.log('后端返回信息:', response);
      if (response.data !== undefined) {
        // 根据后端返回的布尔值判断设备是否存在
        if (response.data.data === true) {
          // 设备存在
          return true;
        // eslint-disable-next-line no-else-return
        } else if (response.data === false) {
          // 设备不存在
          // console.log('设备不存在:', response.data);
          return '设备不存在,请重新输入！';
        }
      }
      // 处理未知情况
      // console.log('后端返回未知数据:', response.data);
      return response.data;
    } catch (error) {
      // 处理异常
      console.error('请求失败:', error);
      return '请求失败，请重试';
    }
  },
});

extend('IsNumberOfDecimalPlacesUpToFour', {
  validate: async value => {
    const NumberOfDecimalPlacesUpToFourReg = /^[0-9]+(\.\d{1,4})?$/;

    if (Number.isNaN(Number(value))) {
      return '必须为数字';
    } if (!NumberOfDecimalPlacesUpToFourReg.test(value)) {
      return '必须是无符号且小数位数小于4位的数字';
    }
    return true;
  },
});

extend('validJson', {
  validate: async value => {
    try {
      const obj = JSON.parse(value.replace(/[\r|\n|\t]/g, ''));
    } catch (exception) {
      return false;
    }
    return true;
  },
});
